import React, { useState, useEffect, Fragment } from 'react'
import { Cookie } from '@mercadona/mo.library.web-services/cookies'
import { CookieBanner } from '@mercadona/mo.library.shop-ui/cookie-banner'
import i18next from 'i18next'

import { Tracker } from 'services/tracker'

import { CookieConfiguration } from 'app/cookie/components/cookie-configuration'
import { COOKIES, NECESSARY_COOKIES } from 'app/cookie/constants'

const {
  REACT_APP_ACCEPTED_COOKIES,
  REACT_APP_COOKIE_DOMAIN,
  REACT_APP_COOKIES_POLICY,
} = process.env

const isNecessaryCookie = (cookieName) => {
  return (
    NECESSARY_COOKIES.includes(cookieName) ||
    cookieName.startsWith(COOKIES.AMPLITUDE_ID)
  )
}

const isCurrentCookieVersion = () => {
  const { REACT_APP_COOKIES_VERSION } = process.env
  const currentVersion = Number(REACT_APP_COOKIES_VERSION)
  const cookie = Cookie.get(REACT_APP_ACCEPTED_COOKIES)

  const isNotVersionDefined = currentVersion === 0
  const isCurrentVersion = cookie.version === currentVersion

  return isCurrentVersion || isNotVersionDefined
}

const CookieContainer = () => {
  const [isCookieBannerOpen, setCookieBannerOpen] = useState(true)
  const [isCookiesConfigurationOpen, setCookiesConfigurationOpen] =
    useState(false)

  useEffect(() => {
    const isOpenedFromShop = window.location.href.includes('cookieConfig=true')
    const cookie = Cookie.get(REACT_APP_ACCEPTED_COOKIES)

    if (isOpenedFromShop) setCookiesConfigurationOpen(true)
    if (!cookie) return
    if (!isCurrentCookieVersion()) {
      Cookie.remove(REACT_APP_ACCEPTED_COOKIES, REACT_APP_COOKIE_DOMAIN)
      return
    }

    setCookieBannerOpen(false)
  }, [])

  const removeThirdPartyCookies = () => {
    const cookies = document.cookie.split('; ')

    cookies.forEach((cookie) => {
      const cookieName = cookie.split('=')[0]
      if (isNecessaryCookie(cookieName)) return

      Cookie.remove(cookieName, REACT_APP_COOKIE_DOMAIN)
    })
  }

  const acceptCookies = (isThirdPartyAccepted) => {
    const { REACT_APP_COOKIES_VERSION } = process.env
    const versionedCookie = {
      thirdParty: isThirdPartyAccepted,
      necessary: true,
      version: Number(REACT_APP_COOKIES_VERSION),
    }
    Cookie.save(
      versionedCookie,
      REACT_APP_ACCEPTED_COOKIES,
      REACT_APP_COOKIE_DOMAIN,
    )
    setCookieBannerOpen(false)

    if (!isThirdPartyAccepted) return removeThirdPartyCookies()
    Tracker.initialize()
  }

  return (
    <Fragment>
      {isCookieBannerOpen && (
        <CookieBanner
          altText="cookie"
          messageText={i18next.t('alert_cookies_message')}
          moreInfoText={i18next.t('alert_more_info_cookies_terms')}
          andText={i18next.t('alert_cookies_and')}
          configurationText={i18next.t('alert_cookies_configuration')}
          acceptButtonText={i18next.t('alert_cookies_accept_button')}
          currentLanguage={i18next.language || 'es'}
          legalLink={REACT_APP_COOKIES_POLICY}
          openConfiguration={() => setCookiesConfigurationOpen(true)}
          onClick={() => acceptCookies(true)}
          onReject={() => acceptCookies(false)}
          rejectButtonText={i18next.t('alert_cookies_reject_button')}
        />
      )}
      {isCookiesConfigurationOpen && (
        <CookieConfiguration
          closeConfiguration={() => setCookiesConfigurationOpen(false)}
          acceptCookies={acceptCookies}
        />
      )}
    </Fragment>
  )
}

export { CookieContainer }
